import { GoogleMap, InfoWindow, Marker } from "@react-google-maps/api";
import { useState } from "react";

const Map = (props) => {
  const { isLoaded } = props;
  const [selectedMarker, setSelectedMarker] = useState("");
  const containerStyle = {
    width: "100%",
    height: "800px",
  };

  const center = {
    lat: 46.798059123779936,
    lng: 7.943278642909686,
  };
  const points = [
    {
      id: 1,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-chCHHZBRN&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Hertz 24/7 Bern
        </a>
      ),
      location: { lat: 46.946821297634784, lng: 7.44779142883622 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-chCHHZBRN&product=HOURLY_RENTAL",
    },
    {
      id: 2,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-chCHHZWIN&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Hertz 24/7 Winterthur
        </a>
      ),
      location: { lat: 47.49677115, lng: 8.73186374 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-chCHHZWIN&product=HOURLY_RENTAL",
    },

    {
      id: 3,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-chCHPLACEB&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Hertz 24/7 Place B Zug
        </a>
      ),
      location: { lat: 47.1869141, lng: 8.4869305 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-chCHPLACEB&product=HOURLY_RENTAL",
    },
     {
      id: 4,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-chCHHZLUG&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Hertz 24/7 Lugano
        </a>
      ),
      location: { lat: 46.0076413, lng: 8.9477586 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-chCHHZLUG&product=HOURLY_RENTAL",
    },
  ];

  return (
    isLoaded && (
      <>
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={center}
          zoom={7}
          options={{
            streetViewControl: false,
            mapTypeControl: false,
          }}
        >
          {points.map((point) => {
            return (
              <div key={point.id}>
                <Marker
                  position={point.location}
                  options={{
                    icon: "https://images.hertz.com/content/dam/hod/images/en-gb/static/Location_Pin.png",
                  }}
                  onClick={() => {
                    setSelectedMarker(point);
                  }}
                />
              </div>
            );
          })}
          {selectedMarker && (
            <InfoWindow
              position={selectedMarker.location}
              options={{
                pixelOffset: new window.google.maps.Size(0, -40),
              }}
              onCloseClick={() => setSelectedMarker("")}
            >
              <>
                <h6>{selectedMarker.name}</h6>
                <button
                  className="btn btn-warning"
                  onClick={() => (window.location.href = selectedMarker.ufoUrl)}
                >
                  Jetzt buchen
                </button>
              </>
            </InfoWindow>
          )}
        </GoogleMap>
      </>
    )
  );
};

export default Map;
